
import Typography from '@/ui-kit/components/typography';
import { Comparator } from '@/ui-kit/enums';
import { Breakpoints } from '@/ui-kit/styles/constants';
import { TypographyType } from '@/ui-kit/components/typography/enums';
import Button from '@/ui-kit/components/button';
import {
  StyleFontWeightType,
  StyleColorSchemeType,
  StylePositionType,
  StyleSizeType,
} from '@/ui-kit/styles/enums';
import StyleClassNamesBuilder from '@/ui-kit/styles/helpers/StyleClassNamesBuilder';
import LazyImage from '@/components/lazy-image';
import ImageHelper from '@/utils/ImageHelper';

export default {
  name: 'ListWithImage',
  components: {
    Typography,
    LazyImage,
    Button,
  },
  props: {
    list: {
      type: Array,
      default: () => ([]),
    },
    image: {
      type: Object,
      default: () => ({}),
    },
    buttonText: {
      type: String,
      default: '',
    },
    redirectTo: {
      type: String,
      default: '',
    },
    trackEvent: {
      type: String,
      default: '',
    },
    reverse: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      TypographyType,
      StyleFontWeightType,
      StyleColorSchemeType,
      StylePositionType,
      StyleSizeType,
    };
  },
  computed: {
    listImageClassNames() {
      return new StyleClassNamesBuilder('my-abode-overview-main-section-list-image')
        .addConditionClassName('reverse', this.reverse)
        .build();
    },
    listImageBackgroundClassNames() {
      return new StyleClassNamesBuilder('my-abode-overview-main-section-list-image__side--background')
        .addClassName('my-abode-overview-main-section-list-image__side')
        .build();
    },
    imageRatio() {
      return ImageHelper.constructor.getImageRatio(this.image.dimensions);
    },
    imageSizes() {
      return [
        {
          comparator: Comparator.Less,
          breakpoint: Breakpoints.XSmall,
          imageSize: 400,
        },
        {
          comparator: Comparator.Less,
          breakpoint: Breakpoints.Small,
          imageSize: 600,
        },
        {
          comparator: Comparator.Greater,
          breakpoint: Breakpoints.Medium,
          imageSize: 700,
        },
      ];
    },
  },
};
